import { PageType } from "__generated__/globalTypes";

import { AzureConfigurator } from "../../../../services/azure-configurator/azure-configurator";
import { DetailedPageType, CategoryPage } from "../types";

export const checkRefUrlFlag = (pageLocale: string, pageType?: DetailedPageType) => {
  let flag: boolean | undefined;

  switch (pageType) {
    case PageType.Pdp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList
          ?.bloomreachRefUrlPdpSimilarItems?.enabled;
      break;
    case PageType.Rbp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrlRbp
          ?.enabled;
      break;
    case PageType.SearchResults:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrlSrp
          ?.enabled;
      break;
    case CategoryPage.Plp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrlPlp
          ?.enabled;
      break;
    case CategoryPage.Clp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrlClp
          ?.enabled;
      break;
    default:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrl
          ?.enabled;
  }

  if (typeof flag !== "boolean") {
    flag =
      AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachRefUrl
        ?.enabled;
  }

  return flag;
};
